import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'

import { onLineTranslateAPI, queryTypeAPI } from '@/api/mt/index'
import { Message } from 'element-ui'
import { debounce } from 'lodash'
import { ILanguageTypeRes, IMtRes } from '@/api/mt/type'
import { languageMap } from './type'
import { copyText } from '@/utils/jClipboard'


export default /*#__PURE__*/_defineComponent({
  __name: 'MtTxt',
  setup(__props) {

const copyDisabled = ref(true)
const leftValue = ref('')
const languageValue = ref('cn2en')
const defaultLanguage = ref<ILanguageTypeRes[]>([])
const translateRes = ref<IMtRes.ISegmentsItem[]>([])

// 获取翻译语种类型
async function getTypeAll () {
  const res = await queryTypeAPI()
  defaultLanguage.value = res.data
}
getTypeAll()

// 原文和翻译结果对应的索引
const currentIndex = ref(-1)
watch(() => leftValue.value, (val) => {
  if (!val) reset()
})

function reset () {
  translateRes.value = []
  copyDisabled.value = true
}

// 悬浮文本行
function hoverText (index: number) {
  handleScroll()
  currentIndex.value = index
}

function leaveText () {
  currentIndex.value = -1
}

// 点击翻译查看结果
async function handleTranslate () {
  try {
    const newText = leftValue.value.replace(/\n/g, '<&>')
    if (!newText.trim()) return
    const res = await onLineTranslateAPI({
      content: newText,
      language: languageValue.value
    })
    translateRes.value = res.data ? res.data : []
    translateRes.value.forEach((item) => {
      item.translated = item.translated?.replace(/<&>/g, '<br>')
      item.origin = item.origin?.replace(/<&>/g, '<br>')
    })
    copyDisabled.value = false
  } catch (error) {
    console.log(error)
  }
}

// 自动匹配语种
async function getLanguageType () {
  handleTranslate()
}

// 实时输入
const handleInput = debounce(getLanguageType, 1000)

function handleCopy () {
  const dom = document.querySelector('.edit-wrapper')
  if (!dom?.textContent) return
  copyText(dom?.textContent)
    .then(() => {
      Message.success('复制成功')
    })
    .catch((e) => {
      Message.error('复制失败')
      console.log(e)
    })
}

function handleScroll () {
  const editDOM = document.querySelector('.edit-wrapper')
  const hoverDOM = document.querySelector('.hover-content')
  const inputDOM = document.querySelector('.el-textarea__inner')
  if (!editDOM || !hoverDOM) return
  const scale = editDOM?.scrollTop / editDOM?.scrollHeight * hoverDOM?.scrollHeight
  const isBottom = (editDOM?.scrollTop + editDOM.clientHeight) / editDOM?.scrollHeight === 1
  hoverDOM?.scrollTo({ top: isBottom ? hoverDOM.scrollHeight : scale })
  inputDOM?.scrollTo({ top: isBottom ? hoverDOM.scrollHeight : scale })
}

return { __sfc: true,copyDisabled, leftValue, languageValue, defaultLanguage, translateRes, getTypeAll, currentIndex, reset, hoverText, leaveText, handleTranslate, getLanguageType, handleInput, handleCopy, handleScroll }
}

})